import { render, staticRenderFns } from "./Territory.vue?vue&type=template&id=5be6ab40&"
import script from "./Territory.vue?vue&type=script&lang=js&"
export * from "./Territory.vue?vue&type=script&lang=js&"
import style0 from "./Territory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports